











import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import UserRoutes from '@/app/api-routes/user-routes';
import i18next from 'i18next';

@Component
export default class WalletButton extends Vue {
  @Action
  public generateWalletPass!: any;

  @Getter('loggedInUser')
  public loggedInUser!: any;

  @Prop(String)
  taxId!: string;

  @State
  public customerUUID!: any;

  public os!: string;

  public walletValid: boolean = true;

  public downloadInProgress: boolean = false;

  public googleWalletURL: string = "javascript:void(0);";

  public created() {
    this.os = navigator.userAgent.match(/iPad|iPhone|iPod/) ? 'ios' : 'other';
    //Debug
    //this.os = 'ios';
    if (this.os == 'other') this.getGoogleWalletJWT();
    else this.testWalletPass();
  }

  public async downloadWalletPass() {
    if (this.downloadInProgress) return;

    this.downloadInProgress = true;
    const url = this.walletPassUrl;
    // push current to ensure the user returns to the same page when closing wallet window
    window.history.pushState({}, document.title, window.location.toString());
    window.location.replace(url);
    setTimeout(() => {
      this.downloadInProgress = false;
    }, 1000);
  }

  public getGoogleWalletJWT() {
    let userId = '';
    if (this.loggedInUser) {
      userId = this.loggedInUser.userId;
    }
    this.generateWalletPass({ taxId: this.taxId, os: this.os, userId: userId })
      .then((response: any) => {
        // @ts-ignore
        const saveUrl = `https://pay.google.com/gp/v/save/${response.jwt}`;
        this.googleWalletURL = saveUrl;
      })
      .catch(() => {
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: i18next.t('transactionOverview.transaction.cancelDialog.error.title'),
            message: i18next.t('transactionOverview.transaction.cancelDialog.error.body'),
          },
        });
      });
  }

  private async testWalletPass() {
    const response = await fetch(this.walletPassUrl);
    if (!response.ok) this.walletValid = false;
  }

  private get walletPassUrl() {
    let userId = '';
    if (this.loggedInUser) {
      userId = this.loggedInUser.userId;
    }
    return UserRoutes.generateWalletPass(this.customerUUID, this.taxId, this.os, userId);
  }
}
